export const getShareableLink = (state) => state.shareableLink;

export const getLink = (state) => getShareableLink(state).link;

export const getIsLoading = (state) => getShareableLink(state).isLoading;

export const getLinkStatus = (state) => getLink(state).status;

export const getLinkId = (state) => getLink(state).id;
